import React, { Component } from 'react';

// Import custom Components 
import Homepage from '../components/dashboard/home';
import ClassesPage from '../components/dashboard/Classes';
import PortalUser from '../components/dashboard/PortalUser';
import Settings from '../components/dashboard/Settings';
import TeacherPage from '../components/dashboard/Teachers';
import MerchantPage from '../components/dashboard/Merchant';
import StudentPage from '../components/dashboard/Student';
import ClassProfile from '../components/dashboard/ViewClass';
import GatePage from '../components/dashboard/Gate';
import ComplainPage from '../components/dashboard/Complain';
import CrowdfundingPage from '../components/dashboard/Crowdfunding';
import AnnouncementPage from '../components/dashboard/Announcement';
import CrowdfundingDetailPage from '../components/dashboard/CrowdfundingDetail';
import ListGoodDeedsPage from '../components/dashboard/ListGoodDeeds';
import AmalanBaikDashboard from '../components/dashboard/AmalanBaikDashboard';
import AmalanBaikAttendanceDashboard from '../components/dashboard/AmalanBaikAttendanceDashboard';
import LatecomerAnalytics from '../components/dashboard/LateComerAnalytics';
import SchoolConfigPage from '../components/dashboard/SchoolConfig';
import CustomAttendancePage from '../components/dashboard/CustomAttendance';
import AuditTrailTable from '../components/dashboard/Logs';
import DownloadAttendancePage from '../components/dashboard/DownloadAttendance';
import ListAmaranBurukPage from '../components/dashboard/AmalanBuruk/ListAmalanBuruk';
import AmalanBurukDashboard from '../components/dashboard/AmalanBuruk/AmalanBurukDashboard';
import SchoolHolidayConfig from '../components/dashboard/SchoolHolidayConfig';
import RMTProfile from '../components/dashboard/ViewRMT';
import CustomCheckerDetailPage from '../components/dashboard/CustomAttendanceChecker';
import FeeConfigDashboard from '../components/dashboard/Fees/FeeConfig';
import FeeConfigPayers from '../components/dashboard/Fees/FeePayers';
import UniversalCertificateGenerator from '../components/dashboard/eCertificate/ECertificate';
import PAJSKDashboard from '../components/dashboard/Pajsk/PajskDashboard';
import StudentProfilePage from '../components/dashboard/StudentProfile/StudentProfileDashboard';

export const routes = [
    { path: `/dashboard`, Component: <Homepage /> },
    { path: `/classes`, Component: <ClassesPage /> },
    { path: `/lateComer`, Component: <LatecomerAnalytics /> },
    { path: `/amalanBaik`, Component: <ListGoodDeedsPage /> },
    { path: `/amalanBaikDashboard`, Component: <AmalanBaikDashboard /> },
    { path: `/crowdfunding`, Component: <CrowdfundingPage /> },
    { path: `/crowdfunding-details/:id`, Component: <CrowdfundingDetailPage /> },
    { path: `/gate`, Component: <GatePage /> },
    { path: `/class-details/:id`, Component: <ClassProfile /> },
    { path: `/student`, Component: <StudentPage /> },
    { path: `/merchant`, Component: <MerchantPage /> },
    { path: `/teacher`, Component: <TeacherPage /> },
    { path: `/portalUser`, Component: <PortalUser /> },
    { path: `/settings`, Component: <Settings /> },
    { path: `/bulletin`, Component: <AnnouncementPage /> },
    { path: `/feedback`, Component: <ComplainPage /> },
    { path: `/schoolConfiguration`, Component: <SchoolConfigPage /> },
    { path: `/customAttendance`, Component: <CustomAttendancePage /> },
    { path: `/customAttendanceDetail`, Component: <CustomCheckerDetailPage /> },
    { path: `/auditLog`, Component: <AuditTrailTable /> },
    { path: `/downloadAttendance`, Component: <DownloadAttendancePage /> },
    { path: `/masalahDisiplinList`, Component: <ListAmaranBurukPage /> },
    { path: `/masalahDisiplinDashboard`, Component: <AmalanBurukDashboard /> },
    { path: `/schoolHolidayConfig`, Component: <SchoolHolidayConfig /> },
    { path: `/feeConfigDashboard`, Component: <FeeConfigDashboard/>},
    { path: `/feeConfigDashboard/:configId/payers`, Component: <FeeConfigPayers /> },
    { path: `/rmt`, Component: <RMTProfile /> },
    { path: `/studentProfile`, Component: <StudentProfilePage/>},
    { path:`/eCertificateGenerator`, Component:<UniversalCertificateGenerator/>},
    { path: `/pajskDashboard`, Component: <PAJSKDashboard/>},
    { path: `/attendance-dashboard`, Component: <AmalanBaikAttendanceDashboard/> }
]
